import { createFileRoute } from '@tanstack/react-router'
import CheckoutPage from '../../screens/Checkout'
// The checkout route mounts only shared pieces (no theme slots), so the
// default stylesheet — bundled with the lazy default theme chunk — would
// never load on a direct entry / refresh here. Import it statically; its
// rules are scoped to [data-theme="default"][data-checkout], so they are
// inert for the other themes.
import '../../themes/default/theme.css'

export const Route = createFileRoute('/c/checkout')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>
    <CheckoutPage />
  </div>
}
